(function( ) {

	$( document ).ready(function() {

		if( jQuery().fancybox ) {

			$( '.modal-iframe-trigger' ).fancybox({
				type : 'iframe',
				baseClass : 'modal-iframe-wrap',
				afterShow : function(){
					$( this.$iframe ).attr( 'tabindex', 0 ).focus();
				}
			});

			$( '.modal-video-trigger' ).fancybox({
				baseClass : 'modal-video-wrap'
			});

			//set form variable for newsletter
			var form = $( '.form-newsletter-form' );

			$( '.modal-form-trigger' ).fancybox({

				type : 'inline',

				baseClass : 'modal-inline-wrap',
				afterClose : function(){

					$( '.form-newsletter-title', form ).text( 'Sign-up to Receive Special Offers and News!' );
					$( '.form-newsletter-message', form ).html( '' );
					$( '#form-newsletter-consent', form ).prop( 'checked', false );
					$( '.input-group', form ).css( 'display', 'block' );
					$( '.form-newsletter-submit-button').css( 'background-color', '#D13239');
					$( '.form-newsletter-submit-button').html('Subscribe Now')
					$( '.form-newsletter-submit' ).css( 'display', 'block' );

				}

			});

			$( '.sticky-link-inner' ).fancybox({
				type : 'inline',
				baseClass : 'modal-inline-wrap',
				touch: false,
				afterClose : function(){

					$inputs = $( '.contest-input' );

					$inputs.each( function() {

						$( this ).val( '' );

					});

					$( '#form-contest-terms-consent' ).prop( 'checked', false );
					$( '#form-contest-newsletter' ).prop( 'checked', false );

					$( '.form-contest-inner' ).show();
					$( '.form-contest-legal' ).show();
					$( '.form-contest-confirmation' ).hide();
					$( '.form-contest-already-submitted' ).hide();

				}

			});

			$( '.modal-inline-trigger' ).fancybox({
				type : 'inline',
				baseClass : 'modal-inline-wrap'
			});

		}

		$( '[data-toggle-active]' ).on( 'click', function( event ){

			event.preventDefault();

			var target = $( this ).data( 'toggle-active' );
			$( event.currentTarget ).toggleClass( 'active' );
			$( target ).toggleClass( 'active' );

			return false;

		});

		$( '[data-toggle-active-form]' ).on( 'click', function( event ){

			event.preventDefault();

			var target = $( this ).data( 'toggle-active-form' );
			$( event.currentTarget ).toggleClass( 'active' );
			$( target ).toggleClass( 'active' );
			$( target ).focus();

			return false;

		});

		// section sliders
		var $slider = $( '.shopify-section.slider' );

		$slider.slick({
			infinite : true,
			slidesToShow : 1,
			slidesToScroll : 1,
			arrows : false,
			dots : $slider.children().length > 1,
			autoplay : true,
			autoplaySpeed : 5000,
			pauseOnHover : true,
			pauseOnDotsHover : true,
			adaptiveHeight : true
		});

		$( '.scroller-wrap' ).slick({
			infinite : true,
			slidesToShow : 5,
			slidesToScroll : 1,
			arrows : false,
			dots : false,
			responsive: [
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 1
					}
				},
				{
					breakpoint: 960,
					settings: {
						slidesToShow: 3
					}
				}
			]
		});

		// globally open external links in a new window

		var links = document.links;

		for (var i = 0, linksLength = links.length ; i < linksLength ; i++) {
			if (links[i].hostname !== window.location.hostname) {
				links[i].target = '_blank';
				links[i].rel = 'noreferrer noopener';
			}
		}


		// resize iframes
		var iframes = $( 'iframe' );

		iframes.each(function(){

			$( this ).data( 'ratio', this.height / this.width ).removeAttr( 'width' ).removeAttr( 'height' );

		});

		$( window ).resize(function(){

			iframes.each(function(){

				var width = $( this ).parent().width();
				$( this ).width( width ).height( width * $( this ).data( 'ratio' ) );

			});

		}).resize();

		if( $( '.sticky-link' ).length > 0 ) {

			$( '.sticky-link' ).removeClass( 'hidden' );

		}

		if( document.cookie.indexOf( 'clearedCache' ) == -1 ) {

			document.cookie = 'cart=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
			document.cookie = 'cart_sig=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
			document.cookie = 'cart_ts=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
			document.cookie = 'cart=; Path=/; domain=.fujifilmprintlife.ca; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

			document.cookie='clearedCache=true';

		}

		var scrollPostion = 0;

		$( window ).scroll( function() {

			scrollPostion = $( window ).scrollTop();

			//if sticky link is on the page, slides it offscreen so it doesn't block footer when the user scrolls to the bottom of the page
			if( $( '.sticky-link' ).length > 0 ) {

				var winheight = $( window ).height()
				var docheight = $( document ).height()
				var trackLength = docheight - winheight
				var pctScrolled = Math.floor( scrollPostion / trackLength * 100 )

				if( pctScrolled >= 99 ) {

					$( '.sticky-link' ).addClass( 'hidden' );

				} else if ( pctScrolled < 99 && !$( '.sticky-link' ).hasClass( 'perma-hidden' ) ) {

					$( '.sticky-link' ).removeClass( 'hidden' );

				}

			}

		});

		$( '[data-toggle-close]' ).on( 'click', function( event ){

			event.preventDefault();

			var target = $( this ).data( 'toggle-close' );

			$( '.' + target ).removeClass( 'active' );

			return false;

		});

		if (document.cookie.includes( 'stickyLinkHidden' )) {

			$( '.sticky-link' ).addClass( 'perma-hidden' );

		}

		$( '.js-close-sticky-link' ).on( 'click', function() {

			$( '.sticky-link' ).addClass( 'perma-hidden' );

			document.cookie = 'stickyLinkHidden=true;max-age=' + (60 * 60 * 24); // hide for 1 day

		});


		$( '.accordion-title' ).on( 'click', function(){

			var $accordion = $( this ).parent( '.accordion' );
			var $content = $accordion.find( '.accordion-content' );

			$content.slideToggle();
			$accordion.toggleClass( 'active' );

			var expanded = $accordion.hasClass( 'active')  ? 'true' : 'false';
			$accordion.find( '.accordion-svg' ).attr( 'aria-expanded', expanded );

			var $chevron = $accordion.find( '.accordion-svg svg' );

			if ( expanded === 'true' ) {

				$chevron.css( 'transform', 'rotate(-90deg)' );

			} else {

				$chevron.css( 'transform', 'rotate(90deg)' );

			}

		});


		// Check if the browser is Safari
		var isSafari = /^((?!chrome|android).)*safari/i.test( navigator.userAgent );

		if (isSafari) {

			$( 'ol' ).css( 'padding-left', '5px' );

		}


		$(document).on('keydown', function(event) {

			var modal = $( '.js-is-modal:not(.hidden)' );

			if ( modal.length > 0 ) {

				var focusableElements = modal.find( 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])' );
				var firstFocusableElement = focusableElements.first();
				var lastFocusableElement = focusableElements.last();

				if ( event.key === 'Tab' ) {
					if (event.shiftKey) {

						if ( $(document.activeElement).is( firstFocusableElement ) ) {

							event.preventDefault();
							lastFocusableElement.focus();

						}

					} else {

						if ($( document.activeElement ).is( lastFocusableElement )) {

							event.preventDefault();
							firstFocusableElement.focus();

						}
					}
				}
			}
		});

		$( '[data-toggle-active]' ).on( 'click', function( event ){

			var target = $( this ).data( 'toggle-active' );
			$( target ).toggleClass( 'off-screen' );


			if ( !$( target ).hasClass( 'off-screen' )) {

				$( target ).find( 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])' ).first().focus();

			} else {

				var returnElement = $( this ).data( 'return-element' );
				if ( returnElement ) {

					$( returnElement ).focus();

				}

			}

		});

		var pathname = window.location.pathname.replace( "/", "" ).replace( "fr/", "" );

		$( '#link1' ).attr( 'href', ( $( '#link1' ).attr( 'href' ) + pathname ) );
		$( '#link2' ).attr( 'href', ( $( '#link2' ).attr( 'href' ) + '/' + pathname ) );

		if ( document.documentElement.lang.toLowerCase() === "en" ) {

			$( "#link1" ).addClass( "active-language-link" ) ;

		} else {

			$( "#link2" ).addClass( "active-language-link" );

		}

		$( "#link1, #link2" ).click(function() {

			$( "#link1, #link2" ).removeClass( "active-language-link" );

			$( this ).addClass( "active-language-link" );

		});

		if( $( '#product-timestamp' ).length > 0 ) {

			$( '#product-timestamp' ).val( Date.now() );

		}

		if( $( '.pcid-auth' ).length > 0 ) {

			if ( document.documentElement.lang.toLowerCase() === 'fr' ) {

				const domain = window.location.hostname;

				if( domain.includes( 'pharmaprixphoto' ) ) {

					$( '.pcid-auth a' ).attr( 'href', $( '.pcid-auth a' ).attr( 'href' ) + '?lang=fr&referrer=pharmaprix-photo' );

				} else {

					$( '.pcid-auth a' ).attr( 'href', $( '.pcid-auth a' ).attr( 'href' ) + '?lang=fr&referrer=shoppers-photo' );

				}

				$('.pcid-auth a').contents().filter(function() {

					return this.nodeType === 3;

				}).first().replaceWith( 'Connectez-vous avec PCID' );
				$( '.pcid-auth h1' ).text( 'Se Connecter' );

			} else {

				const domain = window.location.hostname;

				if( domain.includes( 'pharmaprixphoto' ) ) {

					$( '.pcid-auth a' ).attr( 'href', $( '.pcid-auth a' ).attr( 'href' ) + '?lang=en&referrer=pharmaprix-photo' );

				} else {

					$( '.pcid-auth a' ).attr( 'href', $( '.pcid-auth a' ).attr( 'href' ) + '?lang=en&referrer=shoppers-photo' );

				}

			}

		}

	});

	$( window ).on('load', function() {
		// Grabbing dates from Shopify
		var startDate = $( '#banner-content ').data( 'start-date' );
		var endDate = $( '#banner-content' ).data( 'end-date' );

		// Turning the data into Date objects
		var startDateObj = new Date( startDate );
		var endDateObj = new Date( endDate );

		function onCountdownEnd() {

			$( '#banner-content' ).hide();
			clearInterval( countdownInterval );

		}

		if ( !isNaN(startDateObj.getTime()) && !isNaN(endDateObj.getTime()) ) {

			var countdownInterval = setInterval(function() {

				var now = new Date();

				if ( now >= startDateObj && now <= endDateObj ) {

					var timeDifference = endDateObj - now;

					if ( timeDifference <= 0 ) {

						onCountdownEnd();

					} else {

						var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
						var hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
						var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
						var seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

						$( '#countdown' ).text( days + "d " + hours + "h " + minutes + "m " + seconds + "s" );
						$( '#banner-content' ).show();

					}

				} else {

					$( '#banner-content' ).hide();

				}

			}, 1000);
		} else {

			console.log("Invalid start or end date format.");

		}

	});

})();
